/**
 * responsive.js
 * Utilitaires pour améliorer l'expérience sur les appareils mobiles
 */

import $ from 'jquery';
import MediaQuery from './media-query';

document.addEventListener('DOMContentLoaded', initResponsive);
document.addEventListener('turbolinks:load', initResponsive);

function initResponsive() {
  // Ajuster les menus déroulants pour les écrans tactiles
  adjustDropdownsForTouch();

  // Gérer l'affichage sur les petits écrans
  handleSmallScreens();

  // Observer les changements de taille d'écran
  window.addEventListener('resize', handleSmallScreens);

  // Initialiser les media queries
  initMediaQueries();
}

function adjustDropdownsForTouch() {
  // Améliorer l'expérience des menus déroulants sur les appareils tactiles
  $('.dropdown-toggle').on('click touchstart', function(e) {
    if (window.innerWidth < 992) {
      e.preventDefault();
      $(this).next('.dropdown-menu').toggleClass('show');
    }
  });

  // Fermer les menus quand on clique ailleurs
  $(document).on('click touchstart', function(e) {
    if (!$(e.target).closest('.dropdown').length) {
      $('.dropdown-menu').removeClass('show');
    }
  });
}

function handleSmallScreens() {
  const isSmallScreen = window.innerWidth < 768;

  // Ajuster les classes pour les petits écrans
  if (isSmallScreen) {
    // Ajuster les tableaux pour qu'ils soient scrollables horizontalement
    $('table.table').not('.responsive-handled').each(function() {
      $(this).addClass('responsive-handled');
      if (!$(this).parent().hasClass('table-responsive')) {
        $(this).wrap('<div class="table-responsive"></div>');
      }
    });

    // Ajuster certains éléments d'UI pour les petits écrans
    $('.d-flex.justify-content-between').not('.responsive-handled').each(function() {
      $(this).addClass('responsive-handled flex-column flex-md-row');
    });

    // Adapter la taille des boutons et des icônes
    $('.btn-group').not('.responsive-handled').each(function() {
      $(this).addClass('responsive-handled d-flex flex-wrap');
    });
/**
 * responsive.js
 * Gère la responsivité globale de l'application
 */

function initResponsive() {
  // Ajuster les menus déroulants pour les écrans tactiles
  adjustDropdownsForTouch();

  // Gérer l'affichage sur les petits écrans
  handleSmallScreens();

  // Observer les changements de taille d'écran
  window.addEventListener('resize', handleSmallScreens);

  // Initialiser les media queries
  initMediaQueries();
}

function adjustDropdownsForTouch() {
  // Sur les appareils tactiles, ajuster le comportement des menus déroulants
  if ('ontouchstart' in window) {
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();

        // Fermer tous les autres dropdowns
        dropdownToggles.forEach(otherToggle => {
          if (otherToggle !== toggle && otherToggle.parentElement.classList.contains('show')) {
            otherToggle.click();
          }
        });
      });
    });
  }
}

function handleSmallScreens() {
  const isMobile = window.innerWidth < 768;

  // Ajuster les éléments en fonction de la taille de l'écran
  if (isMobile) {
    // Ajouter la classe responsive-table à tous les tableaux
    document.querySelectorAll('.table').forEach(table => {
      table.classList.add('responsive-table');
    });

    // Simplifier les éléments de navigation
    document.querySelectorAll('.nav-link').forEach(link => {
      link.classList.add('py-2');
    });
  } else {
    // Restaurer les tableaux en mode normal
    document.querySelectorAll('.table').forEach(table => {
      table.classList.remove('responsive-table');
    });

    // Restaurer la navigation
    document.querySelectorAll('.nav-link').forEach(link => {
      link.classList.remove('py-2');
    });
  }
}

function initMediaQueries() {
  const mediaQueryMobile = window.matchMedia('(max-width: 767.98px)');

  // Gérer les changements de media query
  mediaQueryMobile.addEventListener('change', handleSmallScreens);
}

// Rendre les fonctions disponibles globalement
window.responsiveUtils = {
  initResponsive: initResponsive,
  adjustDropdownsForTouch: adjustDropdownsForTouch,
  handleSmallScreens: handleSmallScreens
};

// Initialiser lors du chargement de la page
document.addEventListener('DOMContentLoaded', initResponsive);

// Réinitialiser lors des navigations Turbolinks
document.addEventListener('turbolinks:load', initResponsive);
    // Optimiser les tables de données pour mobile
    optimizeDataTablesForMobile();
  }
}

function optimizeDataTablesForMobile() {
  // Vérifier si DataTables existe
  if (typeof $.fn.DataTable !== 'undefined') {
    // Ajuster les options de pagination pour mobile
    $('.dataTables_length select').each(function() {
      $(this).addClass('form-select form-select-sm');
    });

    $('.dataTables_filter input').each(function() {
      $(this).addClass('form-control-sm w-100');
    });

    // Ajuster les boutons d'actions pour qu'ils soient plus utilisables sur mobile
    $('.dt-buttons').addClass('d-flex flex-wrap gap-2 mb-3');
    $('.dt-button').addClass('btn-sm');

    // Adapter les paginations pour mobile
    $('.dataTables_paginate').addClass('mt-3 d-flex justify-content-center');
    $('.paginate_button').addClass('page-link-sm');
  }
}

function initMediaQueries() {
  // Initialiser les comportements spécifiques pour chaque breakpoint
  MediaQuery.init({
    xs: function(mq) {
      if (mq.matches) {
        // Comportements spécifiques pour les très petits écrans
        adjustForMobile();
      }
    },
    sm: function(mq) {
      if (mq.matches) {
        // Comportements spécifiques pour les tablettes en portrait
        adjustForTablet();
      }
    },
    md: function(mq) {
      if (mq.matches) {
        // Comportements spécifiques pour les tablettes en paysage
      }
    },
    lg: function(mq) {
      if (mq.matches) {
        // Comportements spécifiques pour les desktop
      }
    }
  });
}

function adjustForMobile() {
  // Réduire la taille des textes dans certains endroits
  $('.navbar-custom .logo-lg').css('font-size', '0.9rem');

  // Ajuster les menus pour le mobile
  $('#mobile-menu-toggle').on('click', function() {
    $('.topnav-menu').toggleClass('show-menu');
  });
}

function adjustForTablet() {
  // Ajustements spécifiques pour les tablettes
  $('.navbar-custom .domain-dropdown-text').css('max-width', '200px');
}
